module.exports = __webpack_public_path__ + "img/veloshop.ca_technicien_Mike.88a22baf.jpg";